/*
 *   File : cancel-sip-confirmation.js
 *   Author : https://evoqins.com
 *   Description : sip cancel confirmation modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';

//custom component
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextInput } from '../Form-Elements';
import SelectionSuggestModal from './select-suggestion';

const SIPConfirmationModal = (props) => {

    const [currentStep, setCurrentStep] = useState(1);
    const [sipCancelReasons, setSipCancelReasons] = useState(props.sipCancelReasons);
    const [selectedReason, setSelectedReason] = useState([]);
    const [reasonError, setReasonError] = useState("");
    const [showReasonModal, setShowReasonModal] = useState(false);

    useEffect(() => {
        setSipCancelReasons(props.sipCancelReasons);
    }, [props]);

    useEffect(() => {

        if (showReasonModal === true) {
            let reason_modal = new Modal(document.getElementById(`select-sip-cancel-reason-modal`));
            reason_modal.show();
        };


    }, [showReasonModal]);

    // handle cancel sip 
    const _handleCancel = () => {
        if (selectedReason.length == 0) {
            setReasonError("Please select cancellation reason");
            return;
        }
        props.cancelSip(selectedReason);
    }

    // handle reason select  
    const _handleSelectReason = (value) => {
        setSelectedReason(value);
        setReasonError("");
    };


    return (
        <div className="modal fade"
            id="sip-confirmation-modal"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="sipConfirmationModalLabel"
            aria-hidden="true">
            <div className="modal-dialog  modal-md ">
                <div className={`modal-content  ${currentStep === 1 ? " e-bg-blur-gradient" : "e-bg-lotion min-h90vh"}  e-border-radius-24 e-addbank-box-shadow`}>
                    {
                        currentStep === 1 ?
                            <>
                                <div className="modal-header border-0 justify-content-end pt-4 pb-0 px-4 ">
                                    <img src={require("../../Assets/Images/close-btn-white.svg").default}
                                        id='kyc-status-modal-close'
                                        draggable={false}
                                        className='cursor-pointer'
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        alt='close'
                                        onClick={props.onCloseModal}
                                    />
                                </div>
                                <div className="modal-body text-center p-4">
                                    <img src={require("../../Assets/Images/KYC/kyc-failure.png")}
                                        draggable={false}
                                        className='col-5'
                                        alt='bank' />
                                    <p className='mb-2 pt-4 e-text-sunset-orange e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                        Are you sure want to cancel
                                    </p>
                                    <p className='mb-0 px-md-4 px-sm-0 px-0 e-text-neutral-dark-gray e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                                        Your SIP helps you stay on track with your financial goals. If you'd still like to stop it, you can continue below.
                                    </p>

                                    <div className='d-flex gap-3 mt-4'>
                                        <SecondaryButton name="Back"
                                            borderRadius="e-border-radius-10"
                                            dismiss="modal"
                                            className="w-100  padding-12px-tb e-bg-lotion e-font-14 e-text-charleston-green e-border-bright-gray"
                                            onPress={props.onClose} />
                                        <PrimaryButton name="Cancel"
                                            className="e-border-radius-10 w-100 padding-12px-top padding-12px-bottom e-primary-button-hover transition"
                                            onPress={() => setCurrentStep(2)} />
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="modal-header justify-content-space-between pt-4  px-4 pb-0 border-0">
                                    <h6 className='mb-2 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                        Confirm SIP Cancellation
                                    </h6>
                                    <img src={require("../../Assets/Images/close-btn.svg").default}
                                        id='sip-confirmation-modal-close'
                                        draggable={false}
                                        className='cursor-pointer'
                                        data-bs-dismiss="modal"
                                        aria-label="close"
                                        alt='close btn'
                                        onClick={props.onClose} />
                                </div>
                                <div className="modal-body px-4 pb-4 pt-2 d-flex flex-column">
                                    <div className='h-90 position-relative mb-sm-2 mt-4'>
                                        <CustomTextInput label="Select cancellation reason*"
                                            placeholder="Select reason"
                                            dropdown={true}
                                            type="text"
                                            floatingLabel={true}
                                            value={selectedReason.name}
                                            errorMsg={reasonError}
                                            readOnly
                                            isOpen={showReasonModal}
                                            className="w-100 px-3 padding-12px-top padding-12px-bottom cursor-pointer"
                                            labelStyle="e-font-weight-500"
                                            onClick={() => setShowReasonModal(true)} />
                                    </div>
                                    <p className='mt-auto mb-4 e-text-neutral-dark-gray e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                                        Are you sure you want to cancel this SIP? <br />
                                        Cancelling will stop all future investments, but your past investments will remain active.
                                    </p>

                                    <div className='d-flex gap-3'>
                                        <SecondaryButton name="No, keep SIP"
                                            id="sip-confirmation-close"
                                            className="flex-grow-1 padding-10px-top padding-10px-bottom e-border-bright-gray e-font-16"
                                            dismiss="modal"
                                            borderRadius="e-border-radius-10"
                                            onPress={props.onClose} />

                                        <PrimaryButton name="Yes, cancel SIP"
                                            className="flex-grow-1 e-border-radius-10 padding-10px-top padding-10px-bottom e-font-16"
                                            onPress={_handleCancel} />
                                    </div>

                                </div>
                            </>
                    }

                </div>
            </div>

            {
                showReasonModal &&
                <SelectionSuggestModal title="SIP cancel Reason"
                    backdrop={"false"}
                    data={sipCancelReasons}
                    type={10}
                    id={`select-sip-cancel-reason-modal`}
                    selectedOption={selectedReason}
                    onSelectOption={_handleSelectReason}
                    onModalClose={() => setShowReasonModal(false)} />
            }

        </div>
    )
}

export default SIPConfirmationModal;